type Permission = {
  [key: string]: string;
};

const permissions: Permission = {
  PERM_VIEW_ORDERS: 'view_orders',
  PERM_VIEW_CUSTOMERS: 'view_customer',
  PERM_VIEW_LINES: 'view_line',
  PERM_VIEW_CITIES: 'view_city',
  PERM_VIEW_ORDER_CONSECUTIVE: 'view_orderconsecutive',
  PERM_VIEW_USERS: 'view_user',
  PERM_VIEW_PROCESS: 'view_process',
  PERM_VIEW_ORDER_PROCESS_LOG: 'view_orderprocesslog',
  PERM_VIEW_ORDER_PROCESS_CONSECUTIVE: 'view_orderprocessconsecutive',
  PERM_VIEW_ORDER_PROCESS_CONSECUTIVE_LOG: 'view_orderprocessconsecutivelog',
  PERM_VIEW_TRANSACTIONS: 'view_transactions',
  PERM_VIEW_ASSIGNMENTS: 'view_assignments',
  PERM_VIEW_DESPACHO: 'view_despacho',
  PERM_VIEW_ALISTARTELA: 'view_alistartela',
  PERM_VIEW_NAME: 'view_name',
  PERM_VIEW_PRODUCT: 'view_product',
  PERM_VIEW_SETTINGS: 'view_settings',
  PERM_VIEW_SIZE: 'view_size',
  PERM_VIEW_USERDETAIL: 'view_userdetail',
  PERM_VIEW_PERMISSION: 'view_permission',
  PERM_VIEW_AGENDA: 'view_agenda',

  PERM_ADD_ORDERS: 'add_orders',
  PERM_ADD_CUSTOMERS: 'add_customer',
  PERM_ADD_LINES: 'add_line',
  PERM_ADD_CITIES: 'add_city',
  PERM_ADD_ORDER_CONSECUTIVE: 'add_orderconsecutive',
  PERM_ADD_USERS: 'add_user',
  PERM_ADD_PROCESS: 'add_process',
  PERM_ADD_ORDER_PROCESS_LOG: 'add_orderprocesslog',
  PERM_ADD_ORDER_PROCESS_CONSECUTIVE: 'add_orderprocessconsecutive',
  PERM_ADD_ORDER_PROCESS_CONSECUTIVE_LOG: 'add_orderprocessconsecutivelog',
  PERM_ADD_TRANSACTIONS: 'add_transactions',
  PERM_ADD_ASSIGNMENTS: 'add_assignments',
  PERM_ADD_DESPACHO: 'add_despacho',
  PERM_ADD_ALISTARTELA: 'add_alistartela',
  PERM_ADD_NAME: 'add_name',
  PERM_ADD_PRODUCT: 'add_product',
  PERM_ADD_SIZE: 'add_size',
  PERM_ADD_USERDETAIL: 'add_userdetail',
  PERM_ADD_PERMISSION: 'add_permission',
  PERM_ADD_SETTINGS: 'add_settings',
  PERM_ADD_AGENDA: 'add_agenda',

  PERM_CHANGE_ORDERS: 'change_orders',
  PERM_CHANGE_CUSTOMERS: 'change_customer',
  PERM_CHANGE_LINES: 'change_line',
  PERM_CHANGE_CITIES: 'change_city',
  PERM_CHANGE_ORDER_CONSECUTIVE: 'change_orderconsecutive',
  PERM_CHANGE_USERS: 'change_user',
  PERM_CHANGE_PROCESS: 'change_process',
  PERM_CHANGE_ORDER_PROCESS_LOG: 'change_orderprocesslog',
  PERM_CHANGE_ORDER_PROCESS_CONSECUTIVE: 'change_orderprocessconsecutive',
  PERM_CHANGE_ORDER_PROCESS_CONSECUTIVE_LOG: 'change_orderprocessconsecutivelog',
  PERM_CHANGE_TRANSACTIONS: 'change_transactions',
  PERM_CHANGE_ASSIGNMENTS: 'change_assignments',
  PERM_CHANGE_DESPACHO: 'change_despacho',
  PERM_CHANGE_ALISTARTELA: 'change_alistartela',
  PERM_CHANGE_NAME: 'change_name',
  PERM_CHANGE_PRODUCT: 'change_product',
  PERM_CHANGE_SETTINGS: 'change_settings',
  PERM_CHANGE_SIZE: 'change_size',
  PERM_CHANGE_USERDETAIL: 'change_userdetail',
  PERM_CHANGE_PERMISSION: 'change_permission',
  PERM_CHANGE_AGENDA: 'change_agenda',

  PERM_DELETE_ORDERS: 'delete_orders',
  PERM_DELETE_CUSTOMERS: 'delete_customer',
  PERM_DELETE_LINES: 'delete_line',
  PERM_DELETE_CITIES: 'delete_city',
  PERM_DELETE_ORDER_CONSECUTIVE: 'delete_orderconsecutive',
  PERM_DELETE_USERS: 'delete_user',
  PERM_DELETE_PROCESS: 'delete_process',
  PERM_DELETE_ORDER_PROCESS_LOG: 'delete_orderprocesslog',
  PERM_DELETE_ORDER_PROCESS_CONSECUTIVE: 'delete_orderprocessconsecutive',
  PERM_DELETE_ORDER_PROCESS_CONSECUTIVE_LOG: 'delete_orderprocessconsecutivelog',
  PERM_DELETE_TRANSACTIONS: 'delete_transactions',
  PERM_DELETE_ASSIGNMENTS: 'delete_assignments',
  PERM_DELETE_NAME: 'delete_name',
  PERM_DELETE_PRODUCT: 'delete_product',
  PERM_DELETE_SETTINGS: 'delete_settings',
  PERM_DELETE_SIZE: 'delete_size',
  PERM_DELETE_USERDETAIL: 'delete_userdetail',
  PERM_DELETE_PERMISSION: 'delete_permission',
  PERM_DELETE_SKETCHREQUESTLOGGER: 'delete_sketchrequestlogger',
  PERM_DELETE_AGENDA: 'delete_agenda',
  PERM_VIEW_REPOSITION: 'view_reposition',
  PERM_VIEW_REPOSITIONS: 'view_repositions',
  PERM_ADD_REPOSITION: 'add_reposition',
  PERM_CHANGE_REPOSITION: 'change_reposition',
  PERM_DELETE_REPOSITION: 'delete_reposition',
  PERM_VIEW_REPOSITIONS_ALL: 'view_repositions_all',
  PERM_VIEW_REPOSITIONS_ASSIGNED: 'view_repositions_assigned',
  PERM_RESOLVE_REPOSITIONS: 'resolve_repositions',
  PERM_CANCEL_REPOSITIONS: 'cancel_repositions',
  PERM_VIEW_ORDERS_ALL: 'view_orders_all',
  PERM_VIEW_ORDERS_OWN: 'view_orders_own',
  PERM_VALIDATE_ORDERS: 'validate_orders',
  PERM_VIEW_SKETCHES_ALL: 'view_sketches_all',
  PERM_VIEW_SKETCHES_ASSIGNED: 'view_sketches_assigned',
  PERM_VALIDATE_SKETCHES: 'validate_sketches',
  PERM_APPROVE_TRANSACTIONS: 'approve_transactions',
  PERM_REJECT_TRANSACTIONS: 'reject_transactions',
  PERM_VIEW_TRANSACTIONS_ALL: 'view_transactions_all',
  PERM_VIEW_TRANSACTIONS_OWN: 'view_transactions_own',
  PERM_VIEW_REPORTS_SALES: 'view_reports_sales',
  PERM_VIEW_REPORTS_PRODUCTION: 'view_reports_production',
  PERM_VIEW_STATS: 'view_stats',
  PERM_VIEW_USERAUDIT: 'view_useraudit',
  PERM_VIEW_DESIGNER_PROBABILITIES: 'view_designersprobabilities',
  PERM_CHANGE_DESIGNER_PROBABILITIES: 'change_designersprobabilities',
  PERM_LIMIT_PRODUCTION_PROCESSES: 'limit_production_processes',
};

const groups = {
  GROUP_CONTROL_DE_CALIDAD: 'Control de Calidad',
  GROUP_PRODUCCION: 'Produccion',
  GROUP_JEFE_DE_PRODUCCION: 'Jefe de Produccion',
  GROUP_JEFE_DE_VENTAS: 'Jefe de Ventas',
  GROUP_VALIDADOR: 'Validador',
  GROUP_VENDEDOR: 'Vendedor',
  GROUP_ADMINISTRADOR: 'Administrador',
};

const process_permissions: Permission = {
  PERM_ADD_PREALISTAMIENTO: 'add_prealistamiento',
  PERM_CHANGE_PREALISTAMIENTO: 'change_prealistamiento',
  PERM_VIEW_PREALISTAMIENTO: 'view_prealistamiento',
  PERM_ADD_MONTAJE: 'add_montaje',
  PERM_CHANGE_MONTAJE: 'change_montaje',
  PERM_VIEW_MONTAJE: 'view_montaje',
  PERM_ADD_VERIFICACIONMONTAJE: 'add_verificacionmontaje',
  PERM_CHANGE_VERIFICACIONMONTAJE: 'change_verificacionmontaje',
  PERM_VIEW_VERIFICACIONMONTAJE: 'view_verificacionmontaje',
  PERM_ADD_VALIDACION: 'add_validacion',
  PERM_CHANGE_VALIDACION: 'change_validacion',
  PERM_VIEW_VALIDACION: 'view_validacion',
  PERM_ADD_IMPRESION: 'add_impresion',
  PERM_CHANGE_IMPRESION: 'change_impresion',
  PERM_VIEW_IMPRESION: 'view_impresion',
  PERM_ADD_SUBLIMACION: 'add_sublimacion',
  PERM_CHANGE_SUBLIMACION: 'change_sublimacion',
  PERM_VIEW_SUBLIMACION: 'view_sublimacion',
  PERM_ADD_VERIFICACIONSUBLIMACION: 'add_verificacionsublimacion',
  PERM_CHANGE_VERIFICACIONSUBLIMACION: 'change_verificacionsublimacion',
  PERM_VIEW_VERIFICACIONSUBLIMACION: 'view_verificacionsublimacion',
  PERM_ADD_CORTE: 'add_corte',
  PERM_CHANGE_CORTE: 'change_corte',
  PERM_VIEW_CORTE: 'view_corte',
  PERM_ADD_ARMADO: 'add_armado',
  PERM_CHANGE_ARMADO: 'change_armado',
  PERM_VIEW_ARMADO: 'view_armado',
  PERM_ADD_COSTURA: 'add_costura',
  PERM_CHANGE_COSTURA: 'change_costura',
  PERM_VIEW_COSTURA: 'view_costura',
  PERM_ADD_REVISIONYEMPAQUE: 'add_revisionyempaque',
  PERM_CHANGE_REVISIONYEMPAQUE: 'change_revisionyempaque',
  PERM_VIEW_REVISIONYEMPAQUE: 'view_revisionyempaque',
};

const permission_labels: Permission = {
  view_orders: 'Ver Ordenes',
  add_orders: 'Crear Ordenes',
  change_orders: 'Editar Ordenes',
  delete_orders: 'Eliminar Ordenes',
  view_customer: 'Ver Clientes',
  add_customer: 'Crear Clientes',
  change_customer: 'Editar Clientes',
  delete_customer: 'Eliminar Clientes',
  view_line: 'Ver Lineas',
  add_line: 'Crear Lineas',
  change_line: 'Editar Lineas',
  delete_line: 'Eliminar Lineas',
  view_city: 'Ver Ciudades',
  add_city: 'Crear Ciudades',
  change_city: 'Editar Ciudades',
  delete_city: 'Eliminar Ciudades',
  view_orderconsecutive: 'Ver Consecutivos',
  add_orderconsecutive: 'Crear Consecutivos',
  change_orderconsecutive: 'Editar Consecutivos',
  delete_orderconsecutive: 'Eliminar Consecutivos',
  view_user: 'Ver Usuarios',
  add_user: 'Crear Usuarios',
  change_user: 'Editar Usuarios',
  delete_user: 'Eliminar Usuarios',
  view_process: 'Ver Procesos',
  add_process: 'Crear Procesos',
  change_process: 'Editar Procesos',
  delete_process: 'Eliminar Procesos',
  view_orderprocess: 'Ver Procesos de Ordenes',
  add_orderprocess: 'Crear Procesos de Ordenes',
  change_orderprocess: 'Editar Procesos de Ordenes',
  delete_orderprocess: 'Eliminar Procesos de Ordenes',
  view_orderprocesslog: 'Ver Log de Procesos',
  add_orderprocesslog: 'Crear Log de Procesos',
  change_orderprocesslog: 'Editar Log de Procesos',
  delete_orderprocesslog: 'Eliminar Log de Procesos',
  view_orderprocessconsecutive: 'Ver Procesos de Consecutivos',
  add_orderprocessconsecutive: 'Crear Procesos de Consecutivos',
  change_orderprocessconsecutive: 'Editar Procesos de Consecutivos',
  delete_orderprocessconsecutive: 'Eliminar Procesos de Consecutivos',
  view_orderprocessconsecutivelog: 'Ver Log de Procesos de Consecutivos',
  add_orderprocessconsecutivelog: 'Crear Log de Procesos de Consecutivos',
  change_orderprocessconsecutivelog: 'Editar Log de Procesos de Consecutivos',
  delete_orderprocessconsecutivelog: 'Eliminar Log de Procesos de Consecutivos',
  view_group: 'Ver Grupos',
  add_group: 'Crear Grupos',
  change_group: 'Editar Grupos',
  delete_group: 'Eliminar Grupos',
  view_processrole: 'Ver Roles de Proceso',
  add_processrole: 'Crear Roles de Proceso',
  change_processrole: 'Editar Roles de Proceso',
  delete_processrole: 'Eliminar Roles de Proceso',
  view_transactions: 'Ver Transacciones',
  add_transactions: 'Crear Transacciones',
  change_transactions: 'Editar Transacciones',
  delete_transactions: 'Eliminar Transacciones',
  view_assignments: 'Ver Asignaciones',
  add_assignments: 'Crear Asignaciones',
  change_assignments: 'Editar Asignaciones',
  delete_assignments: 'Eliminar Asignaciones',
  view_sketchrequests: 'Ver Solicitudes de Bocetos',
  add_sketchrequests: 'Crear Solicitudes de Bocetos',
  change_sketchrequests: 'Editar Solicitudes de Bocetos',
  delete_sketchrequests: 'Eliminar Solicitudes de Bocetos',
  view_stock: 'Ver Inventario',
  add_stock: 'Crear Insumos',
  change_stock: 'Editar Insumos',
  delete_stock: 'Eliminar Insumos',
  view_repositions: 'Ver Reposiciones',
  view_validacion: 'Ver validaciones',
  add_prealistamiento: 'Crear Prealistamiento',
  change_prealistamiento: 'Editar Prealistamiento',
  view_prealistamiento: 'Ver Prealistamiento',
  add_montaje: 'Crear Montaje',
  change_montaje: 'Editar Montaje',
  view_montaje: 'Ver Montaje',
  add_verificacionmontaje: 'Crear Verificacion de Montaje',
  change_verificacionmontaje: 'Editar Verificacion de Montaje',
  view_verificacionmontaje: 'Ver Verificacion de Montaje',
  add_impresion: 'Crear Impresion',
  change_impresion: 'Editar Impresion',
  view_impresion: 'Ver Impresion',
  add_sublimacion: 'Crear Sublimacion',
  change_sublimacion: 'Editar Sublimacion',
  view_sublimacion: 'Ver Sublimacion',
  add_verificacionsublimacion: 'Crear Verificacion de Sublimacion',
  change_verificacionsublimacion: 'Editar Verificacion de Sublimacion',
  view_verificacionsublimacion: 'Ver Verificacion de Sublimacion',
  add_corte: 'Crear Corte',
  change_corte: 'Editar Corte',
  view_corte: 'Ver Corte',
  add_armado: 'Crear Armado',
  change_armado: 'Editar Armado',
  view_armado: 'Ver Armado',
  add_costura: 'Crear Costura',
  change_costura: 'Editar Costura',
  view_costura: 'Ver Costura',
  add_revisionyempaque: 'Crear Revision y Empaque',
  change_revisionyempaque: 'Editar Revision y Empaque',
  view_revisionyempaque: 'Ver Revision y Empaque',
  add_validacion: 'Crear Validación',
  change_validacion: 'Editar Validación',
  add_list: 'Crear Lista',
  change_list:'Editar Lista',
  delete_list: 'Eliminar Lista',
  view_list: 'Ver Lista',
  add_lists: 'Crear Listas',
  change_lists: 'Editar Listas',
  delete_lists: 'Eliminar Listas',
  view_lists: 'Ver Listas',
  add_listitem: 'Crear Item de Lista',
  change_listitem: 'Editar Item de Lista',
  delete_listitem: 'Eliminar Item de Lista',
  view_listitem: 'Ver Item de Lista',
  add_sketchrequestlogger: 'Crear Solicitud de Boceto',
  change_sketchrequestlogger:  'Editar Solicitud de Boceto',
  view_sketchrequestlogger:  'Ver Solicitud de Boceto',
  delete_sketchrequestlogger: 'Eliminar Solicitud de Boceto',
  add_despacho: 'Crear Despacho',
  change_despacho: 'Editar Despacho',
  view_despacho: 'Ver Despacho',
  add_alistartela: 'Crear Alistamiento de Tela',
  change_alistartela: 'Editar Alistamiento de Tela',
  view_alistartela: 'Ver Alistamiento de Tela',
  add_name: 'Crear Nombre',
  change_name: 'Editar Nombre',
  delete_name: 'Eliminar Nombre',
  view_name: 'Ver Nombre',
  add_product: 'Crear Producto',
  change_product: 'Editar Producto',
  delete_product: 'Eliminar Producto',
  view_product: 'Ver Producto',
  change_settings: 'Editar Configuración',
  add_settings: 'Crear Configuración',
  delete_settings: 'Eliminar Configuración',
  view_settings: 'Ver Configuración',
  add_agenda: 'Crear Agenda',
  change_agenda: 'Editar Agenda',
  delete_agenda: 'Eliminar Agenda',
  view_agenda: 'Ver Agenda',
  add_size: 'Crear Talla',
  change_size: 'Editar Talla',
  delete_size: 'Eliminar Talla',
  view_size: 'Ver Talla',
  add_userdetail: 'Crear Detalle de Usuario',
  change_userdetail: 'Editar Detalle de Usuario',
  delete_userdetail: 'Eliminar Detalle de Usuario',
  view_userdetail: 'Ver Detalle de Usuario',
  add_permission: 'Crear Permiso',
  change_permission: 'Editar Permiso',
  delete_permission: 'Eliminar Permiso',
  view_permission: 'Ver Permiso',
  add_alegraintegration: 'Crear Integración Alegra',
  change_alegraintegration: 'Editar Integración Alegra',
  delete_alegraintegration: 'Eliminar Integración Alegra',
  view_alegraintegration: 'Ver Integración Alegra',
  add_category: 'Crear Categoría',
  change_category: 'Editar Categoría',
  delete_category: 'Eliminar Categoría',
  view_category: 'Ver Categoría',
  add_company: 'Crear Empresa',
  change_company: 'Editar Empresa',
  delete_company: 'Eliminar Empresa',
  view_company: 'Ver Empresa',
  add_contenttype: 'Crear Tipo de Contenido',
  change_contenttype: 'Editar Tipo de Contenido',
  delete_contenttype: 'Eliminar Tipo de Contenido',
  view_contenttype: 'Ver Tipo de Contenido',
  add_designersprobabilities: 'Crear Probabilidades de Diseñadores',
  change_designersprobabilities: 'Editar Probabilidades de Diseñadores',
  delete_designersprobabilities: 'Eliminar Probabilidades de Diseñadores',
  view_designersprobabilities: 'Ver Probabilidades de Diseñadores',
  add_groupot: 'Crear Grupo OT',
  change_groupot: 'Editar Grupo OT',
  delete_groupot: 'Eliminar Grupo OT',
  view_groupot: 'Ver Grupo OT',
  add_groupotline: 'Crear Línea de Grupo OT',
  change_groupotline: 'Editar Línea de Grupo OT',
  delete_groupotline: 'Eliminar Línea de Grupo OT',
  view_groupotline: 'Ver Línea de Grupo OT',
  add_logentry: 'Crear Log',
  change_logentry: 'Editar Log',
  delete_logentry: 'Eliminar Log',
  view_logentry: 'Ver Log',
  add_measurement: 'Crear Medida',
  change_measurement: 'Editar Medida',
  delete_measurement: 'Eliminar Medida',
  view_measurement: 'Ver Medida',
  add_pqrsticket: 'Crear Ticket PQRS',
  change_pqrsticket: 'Editar Ticket PQRS',
  delete_pqrsticket: 'Eliminar Ticket PQRS',
  view_pqrsticket: 'Ver Ticket PQRS',
  add_pqrsticketlogger: 'Crear Log de Ticket PQRS',
  change_pqrsticketlogger: 'Editar Log de Ticket PQRS',
  delete_pqrsticketlogger: 'Eliminar Log de Ticket PQRS',
  view_pqrsticketlogger: 'Ver Log de Ticket PQRS',
  add_processgroupotline: 'Crear Proceso en Línea OT',
  change_processgroupotline: 'Editar Proceso en Línea OT',
  delete_processgroupotline: 'Eliminar Proceso en Línea OT',
  view_processgroupotline: 'Ver Proceso en Línea OT',
  add_processrolepermission: 'Crear Permiso de Rol de Proceso',
  change_processrolepermission: 'Editar Permiso de Rol de Proceso',
  delete_processrolepermission: 'Eliminar Permiso de Rol de Proceso',
  view_processrolepermission: 'Ver Permiso de Rol de Proceso',
  add_processroleuser: 'Crear Usuario en Rol de Proceso',
  change_processroleuser: 'Editar Usuario en Rol de Proceso',
  delete_processroleuser: 'Eliminar Usuario en Rol de Proceso',
  view_processroleuser: 'Ver Usuario en Rol de Proceso',
  add_reposition: 'Crear Reposición',
  change_reposition: 'Editar Reposición',
  delete_reposition: 'Eliminar Reposición',
  view_reposition: 'Ver Reposición',
  add_repositionevidence: 'Crear Evidencia de Reposición',
  change_repositionevidence: 'Editar Evidencia de Reposición',
  delete_repositionevidence: 'Eliminar Evidencia de Reposición',
  view_repositionevidence: 'Ver Evidencia de Reposición',
  add_repositionlog: 'Crear Log de Reposición',
  change_repositionlog: 'Editar Log de Reposición',
  delete_repositionlog: 'Eliminar Log de Reposición',
  view_repositionlog: 'Ver Log de Reposición',
  add_session: 'Crear Sesión',
  change_session: 'Editar Sesión',
  delete_session: 'Eliminar Sesión',
  view_session: 'Ver Sesión',
  add_siigointegration: 'Crear Integración Siigo',
  change_siigointegration: 'Editar Integración Siigo',
  delete_siigointegration: 'Eliminar Integración Siigo',
  view_siigointegration: 'Ver Integración Siigo',
  add_stockpermission: 'Crear Permiso de Insumo',
  change_stockpermission: 'Editar Permiso de Insumo',
  delete_stockpermission: 'Eliminar Permiso de Insumo',
  view_stockpermission: 'Ver Permiso de Insumo',
  add_stocktransaction: 'Crear Transacción de Insumo',
  change_stocktransaction: 'Editar Transacción de Insumo',
  delete_stocktransaction: 'Eliminar Transacción de Insumo',
  view_stocktransaction: 'Ver Transacción de Insumo',
  add_stocktransactionorder: 'Crear Transacción de Insumo por Orden',
  change_stocktransactionorder: 'Editar Transacción de Insumo por Orden',
  delete_stocktransactionorder: 'Eliminar Transacción de Insumo por Orden',
  view_stocktransactionorder: 'Ver Transacción de Insumo por Orden',
  add_task: 'Crear Tarea',
  change_task: 'Editar Tarea',
  delete_task: 'Eliminar Tarea',
  view_task: 'Ver Tarea',
  add_token: 'Crear Token',
  change_token: 'Editar Token',
  delete_token: 'Eliminar Token',
  view_token: 'Ver Token',
  add_tokenproxy: 'Crear Token Proxy',
  change_tokenproxy: 'Editar Token Proxy',
  delete_tokenproxy: 'Eliminar Token Proxy',
  view_tokenproxy: 'Ver Token Proxy',
  add_useraudit: 'Crear Auditoría de Usuario',
  change_useraudit: 'Editar Auditoría de Usuario',
  delete_useraudit: 'Eliminar Auditoría de Usuario',
  view_useraudit: 'Ver Auditoría de Usuario',
  add_userlog: 'Crear Log de Usuario',
  change_userlog: 'Editar Log de Usuario',
  delete_userlog: 'Eliminar Log de Usuario',
  view_userlog: 'Ver Log de Usuario',
  add_vendor: 'Crear Proveedor',
  change_vendor: 'Editar Proveedor',
  delete_vendor: 'Eliminar Proveedor',
  view_vendor: 'Ver Proveedor',
  view_repositions_all: 'Ver Todas las Reposiciones',
  view_repositions_assigned: 'Ver Reposiciones Asignadas',
  resolve_repositions: 'Resolver Reposiciones',
  cancel_repositions: 'Cancelar Reposiciones',
  view_orders_all: 'Ver Todas las Órdenes',
  view_orders_own: 'Ver Órdenes Propias',
  validate_orders: 'Validar Órdenes',
  view_sketches_all: 'Ver Todos los Bocetos',
  view_sketches_assigned: 'Ver Bocetos Asignados',
  validate_sketches: 'Validar Bocetos',
  approve_transactions: 'Aprobar Movimientos',
  reject_transactions: 'Rechazar Movimientos',
  view_transactions_all: 'Ver Todos los Movimientos',
  view_transactions_own: 'Ver Movimientos Propios',
  view_reports_sales: 'Ver Reportes de Ventas',
  view_reports_production: 'Ver Reportes de Producción',
  view_stats: 'Ver Estadísticas',
  limit_production_processes: 'Limitar Procesos de Producción',
  view_menu_orders: 'Ver Menú: Órdenes',
  view_menu_orders_created: 'Ver Menú: Órdenes Creadas',
  view_menu_orders_to_validate: 'Ver Menú: Órdenes Por Validar',
  view_menu_orders_in_process: 'Ver Menú: Órdenes en Proceso',
  view_menu_orders_finished: 'Ver Menú: Órdenes Finalizadas',
  view_menu_orders_bodega: 'Ver Menú: Bodega',
  view_menu_orders_deleted: 'Ver Menú: Órdenes Eliminadas',
  view_menu_processes: 'Ver Menú: Procesos',
  view_menu_repositions: 'Ver Menú: Reposiciones',
  view_menu_repositions_created: 'Ver Menú: Reposiciones Creadas',
  view_menu_repositions_in_process: 'Ver Menú: Reposiciones en Proceso',
  view_menu_repositions_solved: 'Ver Menú: Reposiciones Resueltas',
  view_menu_users: 'Ver Menú: Usuarios',
  view_menu_customers: 'Ver Menú: Clientes',
  view_menu_stats: 'Ver Menú: Estadísticas',
  view_menu_agenda: 'Ver Menú: Agenda',
  view_menu_sketches: 'Ver Menú: Bocetos',
  view_menu_sketches_created: 'Ver Menú: Bocetos Creados',
  view_menu_sketches_to_validate: 'Ver Menú: Bocetos Por Validar',
  view_menu_sketches_changes: 'Ver Menú: Bocetos Con Cambios',
  view_menu_sketches_incomplete: 'Ver Menú: Bocetos Recursos Incompletos',
  view_menu_sketches_approved: 'Ver Menú: Bocetos Aprobados',
  view_menu_transactions: 'Ver Menú: Movimientos',
  view_menu_transactions_unassigned: 'Ver Menú: Movimientos Sin Asignar',
  view_menu_transactions_assigned: 'Ver Menú: Movimientos Asignados',
  view_menu_supplies: 'Ver Menú: Suministros',
  view_menu_audit: 'Ver Menú: Auditoría',
  view_menu_companies: 'Ver Menú: Empresas',
  view_menu_reports: 'Ver Menú: Informes',
  view_menu_settings: 'Ver Menú: Configuraciones',
};

const processStatus = {
  EN_PROCESO: 'En Proceso',
  FINALIZADO: 'Finalizado',
  BLOQUEADO: 'Bloqueado',
  POR_INICIAR: 'Por Iniciar',
};

const orderStatus = {
  EN_PROCESO: 'En Proceso',
  FINALIZADO: 'Finalizado',
  BLOQUEADO: 'Bloqueado',
  CREADA: 'Creada',
  CANCELADA: 'Cancelada',
  POR_VALIDAR: 'Por Validar',
};

const transactionStatus = {
  NO_VALIDADO: 'No Validado',
  VALIDADO: 'Validado',
  RECHAZADO: 'Rechazado',
};

const settings = {
  limitDateDays: 3,
};

const sketchRequestStatus = {
  CREADO: 'Creado',
  EN_DISENO: 'En Diseño',
  POR_VALIDAR: 'Por Validar',
  APROBADO: 'Aprobado',
  CAMBIOS_SOLICITADOS: 'Cambios Solicitados',
  RECURSOS_INCOMPLETOS: 'Recursos Incompletos',
  ASIGNADO: 'Asignado',
};

export const constants = {
  permissions,
  permission_labels,
  groups,
  process_permissions,
  processStatus,
  orderStatus,
  settings,
  transactionStatus,
  sketchRequestStatus,
};
